<template>
  <div class="addExamine" v-loading.fullscreen.lock="loading">
    <Modal v-model="addExamineState" width="950" title="新建/编辑" :mask-closable="false">
      <Form ref="addExamineform" :model="addExamineForm" :rules="ruleCustom" :label-width="150">
        <Row>
          <Col span="12">
            <FormItem label="推荐医师姓名" prop="ysxm">
              <Input v-model="addExamineForm.ysxm" placeholder="请输入推荐医师姓名" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="推荐医师单位" prop="ysdw">
              <Input v-model="addExamineForm.ysdw" placeholder="请输入推荐医师单位" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="推荐医师职务" prop="yszw">
              <Select v-model="addExamineForm.yszw" placeholder="请选择指导老师职务">
                  <Option :value="item.name" v-for="item in postList" :key="item.id">{{item.name}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="推荐医师工作年限" prop="ysgzyx">
              <Input v-model="addExamineForm.ysgzyx" placeholder="请输入推荐医师工作年限" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="推荐医师电话" prop="ysdh">
              <Input v-model="addExamineForm.ysdh" placeholder="请输入推荐医师电话" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="推荐医师通讯地址" prop="ystxdz">
              <Input v-model="addExamineForm.ystxdz" placeholder="请输入推荐医师单位" />
            </FormItem>
          </Col>
        </Row>
        <Row>
          <Col span="12">
            <FormItem label="推荐医师医师资格证书编号" prop="yszgzsbh">
              <Input v-model="addExamineForm.yszgzsbh" placeholder="请输入医师资格证书编号" />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="推荐医师身份证号码" prop="yssfzhm">
              <Input v-model="addExamineForm.yssfzhm" placeholder="请输入医师身份证号码" />
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div slot="footer" style="text-align:center">
        <Button type="primary" icon="md-checkmark" @click="submitClick('addExamineform')">提交</Button>
        <Button type="primary" icon="md-close" @click="addExamineState=false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import util from "@/libs/util";
import {  postDictionaries } from "@/api/dictionaries/index";
import { saveTeacher, updataTeacherNew, getTeacherDetail } from "@/api/declare1/index";
export default {
  props: {
    modalState: {
      type: Boolean,
      default() {
        return false;
      }
    },
    teacherid:{
      type: String,
      default() {
        return '';
      }
    }
  },
  data() {
    const validateidCrd = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入证件号码"));
      } else {
        if (util.tool.checkIDCard(value)) {
          callback();
        } else {
          callback(new Error("身份证号输入错误"));
        }
      }
    };
    return {
      loading: false,
      id:'',
      addExamineState: false,
      obj_id: "",
      addExamineForm: {
        ysxm: "",
        ysdw: "",
        yszw: "",
        ysgzyx: "",
        ysdh: "",
        ystxdz: "",
        yszgzsbh: "",
        yssfzhm: ""
      },
      ruleCustom: {
        ysxm: [
          {
            required: true,
            message: "请输入推荐医师姓名",
            trigger: "blur"
          }
        ],
        ysdw: [
            {
            required: true,
            message: "请输入推荐医师单位",
            trigger: "blur"
          }
        ],
        yszw: [{ required: true,message: '请选择指导老师职务', trigger: 'change' }],
        ysgzyx: [
            {
                required: true,
                message: "请输入推荐医师工作年限",
                trigger: "blur"
            }
        ],
        ysdh:[
            {
                required: true,
                message: "请输入推荐医师电话",
                trigger: "blur"
            }
        ],
        ystxdz:[
            {
                required: true,
                message: "请输入推荐医师单位",
                trigger: "blur"
            }
        ],
        yszgzsbh:[
            {
                required: true,
                message: "请输入推荐医师医师资格证书编号",
                trigger: "blur"
            }
        ],
        yssfzhm: [
          {
            required: true,
            message: "请输入推荐医师身份证号码",
            trigger: "blur"
          },
          {
            validator: validateidCrd,
            trigger: "blur"
          }
        ]
      },
      postList:[]
    };
  },
  watch: {
      modalState() {
          this.addExamineState = true;
      },
      teacherid(id){
        this.id = id;
        if(id ===""){
          this.$refs['addExamineform'].resetFields();
        }else{
          this.getTeacherNew(id);
        }
      }
  },
  created() {
    this.obj_id = util.storage.getUserInfo().obj_id;
    this.getPost();
  },
  methods: {
    //职务数据字典
    getPost() {
        postDictionaries("JoinTitle").then(res => {
            this.postList = res.data_item_dtls;
        });
    },
    // 根据id查询老师信息
    getTeacherNew(id){
      this.loading = true;
      getTeacherDetail(id).then((res) => {
        this.addExamineForm.ysxm = res.name;
        this.addExamineForm.ysdw = res.company;
        this.addExamineForm.yszw = res.title;
        this.addExamineForm.ysgzyx = res.work_year+'';
        this.addExamineForm.ysdh = res.phone;
        this.addExamineForm.ystxdz = res.address;
        this.addExamineForm.yszgzsbh = res.yszg_no;
        this.addExamineForm.yssfzhm = res.idcard_no;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    submitClick(name){
      this.$refs[name].validate((valid) => {
          if (valid) {
            this.loading =true;
            let params ={
              id: this.id,
              user_id: this.obj_id,
              identity_type: 2,
              name: this.addExamineForm.ysxm,
              company: this.addExamineForm.ysdw,
              title:this.addExamineForm.yszw,
              work_year: parseInt(this.addExamineForm.ysgzyx),
              phone: this.addExamineForm.ysdh,
              address: this.addExamineForm.ystxdz,
              yszg_no: this.addExamineForm.yszgzsbh,
              idcard_no: this.addExamineForm.yssfzhm
            }
            if(this.id === ''){
              saveTeacher(params).then(() => {
                this.loading = false;
                this.addExamineState = false;
                this.$refs[name].resetFields();
                this.$Message.success('新增成功!');
                this.$emit("change");
              })
              .catch(() => {
                this.loading = false;
              });
            }else{
              updataTeacherNew(params).then(() => {
                this.loading = false;
                this.addExamineState = false;
                this.$Message.success('修改成功!');
                this.$emit("change");
              })
              .catch(() => {
                this.loading = false;
              });
            }
          }
      })
    }
  }
};
</script>